import React, { Component } from 'react';
import PackageTabB from 'components/PackageTab/PackageTabB';

class PackageTabBContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobileIndex: 0,
    };

    this.moveRight = this.moveRight.bind(this);
    this.moveLeft = this.moveLeft.bind(this);
  }

  moveRight() {
    const { mobileIndex } = this.state;
    this.setState({ mobileIndex: mobileIndex + 1 });
  }

  moveLeft() {
    const { mobileIndex } = this.state;
    this.setState({ mobileIndex: mobileIndex - 1 });
  }

  render() {
    const { mobileIndex } = this.state;
    return (
      <PackageTabB
        moveRight={this.moveRight}
        moveLeft={this.moveLeft}
        mobileIndex={mobileIndex}
        {...this.props}
      />
    );
  }
}

export default PackageTabBContainer;
